module.exports = { "default": require("core-js/library/fn/math/cbrt"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/math/cbrt.js
// module id = 178
// module chunks = 0